export interface AppRelease {
  Id: number;
  VersionNumber: string;
  ReleaseNotes: string;
  IsActive: boolean;
  Platform: number;
  PublicId: string; 
  FileSize: number; // Optional: if you want to track file size
  FileName: string; // Optional: if you want to track the original file name
}

export class CreateDesktopAppRelease {
  VersionNumber: string = '';
  ReleaseNotes: string = '';
  IsActive: boolean = false;
  Platform: number = 1;
  PublicId: string = '';
  FileSize: number = 0; // Optional: if you want to track file size
  FileName: string = ''; // Optional: if you want to track the original file name

  constructor(init?: Partial<CreateDesktopAppRelease>) {
    Object.assign(this, init);
  }
  
}

export enum Platform {
  Windows = 1,
  macOS = 2,
  Linux = 3
}




// WEBPACK FOOTER //
// ./src/app/models/inModels/app-release.model.ts